import {Alpha3CountryCode, Label, PhoneInput, PhoneNumber} from 'platform/components';
import {Show} from 'platform/foundation';

import {Field as FinalFormField, FieldMetaState, UseFieldConfig} from 'react-final-form';
import {useSelector} from 'react-redux';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {selectTenant} from '@dms/api/core';

import {Nullish, TestIdProps} from 'shared/web';

import {selectPhoneNumber, selectPhoneNumbers} from '../../store/common/selectors';
import {FormFieldWrapper} from '../FinalForm/components/FormFieldWrapper';

type PhoneFieldProps = {
  name: string;
  label?: string | Nullish;
  labelTooltip?: string | Nullish;
  parse?: UseFieldConfig<PhoneNumber>['parse'];
  defaultValue?: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  getIsValid: (meta: FieldMetaState<unknown>) => boolean;
  getErrorMessage: (meta: FieldMetaState<unknown>) => string | undefined;
  commonFieldProps?: {
    isRequired?: boolean;
    isDisabled?: boolean;
  };
} & TestIdProps;

/**
 * @deprecated - use platform instead
 */
export const PhoneField = ({
  name,
  label,
  parse,
  commonFieldProps = {},
  defaultValue,
  getIsValid,
  getErrorMessage,
  ...props
}: PhoneFieldProps) => {
  const phoneList = useSelector(selectPhoneNumbers);
  const {data: {country} = {}} = useSelector(selectTenant);

  const phoneNumber = useSelector(selectPhoneNumber(country));

  const defaultPhoneNumber = phoneNumber
    ? {countryCode: phoneNumber.code, prefix: phoneNumber.prefix, number: ''}
    : {countryCode: country};

  return (
    <FinalFormField<PhoneNumber>
      name={name}
      parse={parse}
      defaultValue={defaultValue || defaultPhoneNumber}
    >
      {({input, meta}) => (
        <FormFieldWrapper data-testid={props['data-testid']}>
          <Show when={isNotNilOrEmpty(label)}>
            <Label isRequired={commonFieldProps.isRequired} tooltip={props.labelTooltip}>
              {label}
            </Label>
          </Show>
          <PhoneInput
            {...commonFieldProps}
            isInvalid={!getIsValid(meta)}
            countries={phoneList.map((phone) => ({
              countryCode: phone.code as Alpha3CountryCode,
              dialCode: phone.prefix,
              name: phone.name,
            }))}
            preferredCountries={phoneList
              .filter((phone) => phone.preferred)
              .map((phone) => phone.code as Alpha3CountryCode)}
            value={(input.value || defaultPhoneNumber) as PhoneNumber}
            onChange={input.onChange}
            isDisabled={commonFieldProps.isDisabled}
            data-testid={props['data-testid']}
            errorMessage={getErrorMessage(meta)}
          />
        </FormFieldWrapper>
      )}
    </FinalFormField>
  );
};
